import React, { useEffect, useState, Fragment } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { diaAnterior, diaPosterior, formato_monto, formato_rut } from '../../../common/Formatos'
import { obtenerDatosPantalla } from '../../../store/actions/implicado-action'

const DatosGeneralesModal = ({ ID, formik }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla,comboSeguro,comboCompanias,comboVehiculos,comboMarcas,parametros } = data_datos_implicado
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const [datosSiniestro, setDatosSiniestro] = useState({})
  //Estados de los campos del formulario
  const [fechaSin, setFecha] = useState('')
  const [seguro, setSeguro]=useState("")
  const [compania, setCompania]=useState("")
  const [siniestro, setSiniestro]=useState("")
  const [fechaSiniestro, setFechaSiniestro]=useState("")
  const [vehiculo, setTipoVehiculo]=useState("")
  const [patente, setPatente]=useState("")
  const [marca, setMarca]=useState("")
  const [descripcion, setDescripcion]=useState("")
  useEffect(() => {
    
    setFecha(
      antecedentesCasos &&
        antecedentesCasos.antecedentesCasos[0]['FechaSiniestroFormat']
    )
  }, [antecedentesCasos])
  useEffect(()=>{
    setSeguro(datosPantalla && datosPantalla.length !== 'undefined'
    ? datosPantalla.datosPantalla[0]['IdSeguroImplicado']
    : "")
    setCompania(datosPantalla && datosPantalla.length !== 'undefined'
    ? datosPantalla.datosPantalla[0]['IdCiaImplicado']
    : "")
    setSiniestro(datosPantalla && datosPantalla.length !== 'undefined'
    ? datosPantalla.datosPantalla[0]['SiniestroIM']
    : "")
    setFechaSiniestro(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
    ? convertirFecha(datosPantalla.datosPantalla[0]['FechaSiniestroIMFormat'])
    : "")
    setTipoVehiculo(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
    ?datosPantalla.datosPantalla[0]['IdTipoVehiculo']
    : "")
    setPatente(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
    ?datosPantalla.datosPantalla[0]['Patente']
    : "")
    setMarca(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
    ?datosPantalla.datosPantalla[0]['IdMarca']
    : "")
    setDescripcion(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
    ?datosPantalla.datosPantalla[0]['Descripcion']
    : "")
},[datosPantalla])

const convertirFecha = (fecha) => {
  if (fecha !== null && typeof fecha !== undefined){
    
    const [dia, mes, ano] = fecha?.split('-')
    const fechaFormat = [ano, mes, dia].join('-')

    return fechaFormat
  }else return ''
}
const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}
  return (
    <>
      <Card>
        <Card.Header
          as='h6'
          className='text-center'
          style={{ backgroundColor: '#4F517A', color: 'white' }}
        >
          {cfg_form_implicado &&
            cfg_form_implicado.cfg_form_implicado[
              'gestcasosrecup-editimpl-title-terimplicado'
            ] +
              ' (' +
              ID +
              ')'}
        </Card.Header>
        <Container>
          {cfg_form_implicado ? (
            <div>
              <Container>
            
                <Row>
                  <Col>
                    <Form.Label
                      className='mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplrut'
                        ]
                      }
                    </Form.Label>{' '}
                    <br />
                    <Form.Text className='mb-3'>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? formato_rut(
                            datosPantalla.datosPantalla[0]['RutInvolucrado']
                          )
                        : ''}
                    </Form.Text>
                  </Col>
                  <Col>
                    <Form.Label
                      className=' mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplnombre'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['NombreInvolucrado']
                        : ''}
                    </Form.Text>
                  </Col>
                  <Col>
                    <Form.Label
                      className='mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplgestaplic'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['GlosaTipoGestion']
                        : ''}
                    </Form.Text>
                  </Col>

                  <Col>
                    <Form.Label
                      className='mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplestado'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['EstadoImplicado']
                        : ''}
                    </Form.Text>
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplseguro'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setSeguro(e.target.value)
                        
                      }}
                      name='seguro'
                      value={(formik.values.seguro = seguro)}
                      error={formik.errors.seguro}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboSeguro && comboSeguro.comboSeguro?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.seguro ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.seguro}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplcia'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setCompania(e.target.value)
                        
                      }}
                      name='idCompania'
                      value={(formik.values.idCompania = compania)}
                      error={formik.errors.idCompania}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboCompanias && comboCompanias.comboCompanias.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.idCompania ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.idCompania}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>

                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplsinciaimpl'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setSiniestro(e.target.value)
                        }}
                    name='idSiniestroIM'
                   
                    value={formik.values.idSiniestroIM =siniestro          
                    }
                    error={formik.errors.idSiniestroIM}
                  ></Form.Control>
                  {formik.errors.idSiniestroIM? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.idSiniestroIM}</Form.Text>) :""}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplfechsiniimpl'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    type="date"
                    min={
                      fechaSin && parametros &&
                      diaAnterior(fechaSin, parametros.parametros['valorParametro'])
                    }
                    max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setFechaSiniestro(e.target.value)
                        }}
                    name='fechaSiniestroIM'
                   
                    value={formik.values.fechaSiniestroIM =fechaSiniestro          
                    }
                    error={formik.errors.fechaSiniestroIM} 
                   
                  ></Form.Control>
                  {formik.errors.fechaSiniestroIM ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.fechaSiniestroIM}</Form.Text>) :""}
                  </Col>
                </Row>
              </Container>
              <Container>
                <Row>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimpltipovh'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setTipoVehiculo(e.target.value)
                        
                      }}
                      name='tipoVehiculo'
                      value={(formik.values.tipoVehiculo = vehiculo)}
                      error={formik.errors.tipoVehiculo}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboVehiculos && comboVehiculos.comboVehiculos.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.tipoVehiculo ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.tipoVehiculo}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplpatente'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setPatente(e.target.value)
                        }}
                    name='patente'
                   
                    value={formik.values.patente =patente          
                    }
                    error={formik.errors.patente}
                  ></Form.Control>
                  {formik.errors.patente? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.patente}</Form.Text>) :""}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimplmarca'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setMarca(e.target.value)
                        
                      }}
                      name='marcaVehiculo'
                      value={(formik.values.marcaVehiculo = marca)}
                      error={formik.errors.marcaVehiculo}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboMarcas && comboMarcas.comboMarcas.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.marcaVehiculo ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.marcaVehiculo}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form_implicado.cfg_form_implicado[
                          'gestcasosrecup-editimpl-terimpldesc'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control as="textarea"  className='mt-2 mb-2' rows={2} 
                      onChange={e=>{                    
                        formik.handleChange(e)
                       setDescripcion(e.target.value)
                        
                        }}
                    name='detalleDescripcion'
                   
                    value={formik.values.detalleDescripcion =descripcion          
                    }
                    error={formik.errors.detalleDescripcion}  

                />
                 {formik.errors.detalleDescripcion ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.detalleDescripcion}</Form.Text>) :""}
                  </Col>
                </Row>
              </Container>
            </div>
          ) : ''}
        </Container>
      </Card>
    </>
  )
}

export default DatosGeneralesModal
